module.exports = __webpack_public_path__ + "assets/815106c936d464286311d5fdd0f922bd.mp3";